import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface UserState {
    isHiddenByMenu: boolean
}

const initialState: UserState = {
    isHiddenByMenu: false,
}

const clientCallNotificationSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setIsHiddenByMenu(state, action: PayloadAction<boolean>) {
            state.isHiddenByMenu = action.payload
        },
    },
})

export const clientCallNotificationReducer = clientCallNotificationSlice.reducer

export const { setIsHiddenByMenu } = clientCallNotificationSlice.actions
